import "./ApproveModal.css";

import { Dispatch, SetStateAction } from "react";

import { Button, Column, Modal, Row } from "../../../../widget";
import { useApproveModal } from "./useApproveModal";

interface ApproveModalProps {
  show: boolean;
  onClose: () => void;
  activityUuid: string;
  activityStatus: string;
  activityRowVersion: number;
  activityReviewUuid: string;
  activityReviewStatus: string;
  activityReviewRowVersion: number;
  activityAssessmentUuid: string;
  activityAssessmentStatus: string;
  activityAssessmentRowVersion: number;
  refreshActivityReviews?: boolean;
  setRefreshActivityReviews?: Dispatch<SetStateAction<boolean>>;
}

export const ApproveModal = ({
  show,
  onClose,
  activityUuid,
  activityStatus,
  activityRowVersion,
  activityReviewUuid,
  activityReviewStatus,
  activityReviewRowVersion,
  activityAssessmentUuid,
  activityAssessmentStatus,
  activityAssessmentRowVersion,
  refreshActivityReviews,
  setRefreshActivityReviews,
}: ApproveModalProps): JSX.Element => {
  const { isLoading, onConfirmClick } = useApproveModal({
    onClose,
    activityUuid,
    activityStatus,
    activityRowVersion,
    activityReviewUuid,
    activityReviewStatus,
    activityReviewRowVersion,
    activityAssessmentUuid,
    activityAssessmentStatus,
    activityAssessmentRowVersion,
    refreshActivityReviews,
    setRefreshActivityReviews,
  });

  return (
    <Modal show={show} title="Approve activity" onClose={onClose}>
      <Row spacingV="ll" justify="center">
        <Column span={10}>
          <span className="body1">Approving this activity will complete the activity review process.</span>
        </Column>
      </Row>
      <Row justify="center">
        <Column span={6}>
          <div className="ApproveModalButtons">
            <Button text="Approve" onClick={onConfirmClick} isLoading={isLoading} />
            <Button variant="secondary" text="Cancel" onClick={onClose} />
          </div>
        </Column>
      </Row>
    </Modal>
  );
};
